module.exports = __webpack_public_path__ + "static/img/ikonaFilmDisabled-OFF.36aa48c1.png";